import React from "react";
import htmlParser from "html-react-parser";

import "@ta-interaktiv/semantic-ui/semantic/dist/components/message.css";

import useModal from "hooks/useModal";
import Modal from "../modal";

import { memorials } from "lib/memorials";

function Memorial({
  name,
  content,
  isMobile,
  floatRight,
  currentItem,
  currentPlace,
  updatePlace
}) {
  const memorial = memorials.find(el => el.name === name);

  const gmaps = "https://www.google.ch/maps/search/";
  let positions = [];

  const size = isMobile ? "small" : "medium";
  const float = floatRight ? "right" : "left";

  const [isShowing, toggle] = useModal();

  if (memorial.positions && memorial.positions.length > 0) {
    positions = memorial.positions.map(p => {
      return (
        <li
          key={p.displayName}
          onMouseOver={() => {
            updatePlace(p.displayName);
          }}
          onMouseOut={() => updatePlace(null)}
          className={`place ${
            currentPlace === p.displayName ? "active-place" : null
          }`}
        >
          {p.displayName}: {isMobile ? <br /> : null}
          <a
            href={gmaps + p.position}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="external alternate icon" />
            {p.position[0]}, {p.position[1]}
          </a>
        </li>
      );
    });
  }

  return (
    <div
      // className="item-element-text ui raised segment"
      className="item-element-text ui huge message"
      style={{
        outline:
          currentItem === name ? 1 + "px solid " + memorial.color.hex : ""
      }}
    >
      <h4>
        <i className={`small fitted ${memorial.color.css} circle icon`} />
        {"  "}
        <span className="item-element-title">
          {htmlParser(content[name][1])}
        </span>
      </h4>

      {/* <i className="expand arrows inverted alternate icon" /> */}
      <img
        className={`ui ${size} ${float} floated image item-element-image`}
        src={memorial.image}
        onClick={toggle}
      />

      <div className="item-text">
        {htmlParser(content[name][0])}
        <div>
          <h5>{positions.length > 1 ? "Standorte:" : "Standort:"}</h5>
          <ul>{positions}</ul>
        </div>
      </div>
      <Modal
        image={memorial.image}
        isShowing={isShowing}
        hide={toggle}
        name=""
        position=""
      />
    </div>
  );
}

export default Memorial;
